export function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 44 44" aria-hidden="true">
      <rect x="1" y="1" width="42" height="42" rx="8" fill="currentColor" />
      <path d="M10 11h24v17H21l-7 6v-6h-4z" fill="var(--paper)" />
      <path d="M17 17h11M17 22h8" stroke="var(--blue)" strokeWidth="2.5" strokeLinecap="square" />
    </svg>
  );
}
